export default __webpack_public_path__ + "static/media/lds-logo_ko.12459827b96f5fab.svg";